import StrategyBotContainer from './strategy-bot-container';

export default StrategyBotContainer;
